import React from 'react';

const ReceivedBadge = () => (
  <span className="px-2 py-0.5 rounded text-xs font-medium text-blue-800 bg-blue-100">
    Received
  </span>
);

export default ReceivedBadge;
